import type { GetClientPersonOutput } from '@/entities/client';

import { hasAddressContent } from './has-address-content';

export type LockedPersonFields = {
    emailPrimary: boolean;
    phonePrimary: boolean;
    address: boolean;
};

// A saved value is not overwritten from here, so the field it lives in is locked; an empty one is
// filled in. Decided once from what was loaded, never from the live input, or typing into an empty
// field would lock it mid-keystroke. The address is one unit: any saved part locks every part.
export function buildLockedPersonFields(person: GetClientPersonOutput): LockedPersonFields {
    return {
        emailPrimary: !!person.emailPrimary?.trim(),
        phonePrimary: !!person.phonePrimary?.trim(),
        address: hasAddressContent(person.address),
    };
}
